<template>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        {{ item.code }}
      </span>
    </div>
  </td>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        {{ item.name }}
      </span>
    </div>
  </td>
  <td class="align-middle text-center text-sm">
    <span v-if="item.enabled" class="badge badge-sm bg-gradient-success">Abilitato</span>
    <span v-else class="badge badge-sm bg-gradient-danger">Disabilitato</span>
  </td>
  <td class="align-middle text-center">
    <span class="text-secondary text-xs font-weight-bold">{{ getFormattedDate(item.createdAt) }}</span>
  </td>
</template>

<script>
import moment from "moment";

export default {
  name: "table-customer-row",
  props: {
    item: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods:{
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY")
    },
  }
};
</script>
